import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    title: {
      marginTop: theme.spacing(1),
      color: COLORS.gray.gray30,
      minWidth: 'max-content',
      '& span': {
        color: COLORS.gray.black,
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(32),
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    settingsButton: {
      color: COLORS.gray.gray40,
      padding: theme.spacing(0.5),
      marginLeft: 'auto',
      '&:hover, &:active': {
        backgroundColor: 'unset',
      },
    },
    benchmarkConfig: {
      display: 'flex',
      columnGap: theme.spacing(0.75),
      alignItems: 'center',
    },
    userGoal: {
      color: COLORS.gray.gray30,
    },
    settingsIcon: {
      fontSize: theme.typography.pxToRem(12),
    },
    upgradeWrapper: {
      padding: theme.spacing(1, 2),
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      backgroundColor: COLORS.gray.gray90,
      borderTop: 0,
    },
    bullet: {
      color: COLORS.gray.gray40,
    },
    comparisonSetName: {
      color: COLORS.gray.gray30,
    },
    tooltip: {
      width: 353,
    },
  }),
  { name: 'ConnectedBenchmark' }
);
